import React, { useEffect } from 'react';
import { connect } from 'microfronts-redux';
import { Paragraph, Title, tokens } from '@freightos/design-system';
import styled, { css } from 'styled-components/macro';
import { PAGE_WIDTH } from 'slimSearch/constants';
import { getDeals } from 'slimSearch/actions';
import { dealsSelector, isMobileSelector } from 'slimSearch/selectors';
import { t } from 'utils/translationProvider';
import userModel from 'propera/user';
import preferencesModel from 'propera/preferences';
import Deal from 'slimSearch/components/hotDeals/components/Deal';

const { getPreferences } = preferencesModel;
const { isLoggedIn } = userModel;

export const HotDeals = ({ deals, getDeals, isMobile, isLoggedIn, preferences }) => {
  const { country } = preferences;
  useEffect(() => {
    getDeals();
  }, [getDeals, isLoggedIn, country]);

  if (!deals) {
    return null;
  }

  return (
    <HotDealsWrapper>
      <Title level={4} data-test-id="hot-deals-title">
        {t('hotDeals/title', 'Special offers')}
      </Title>
      <Paragraph type="secondary" data-test-id="hot-deals-subtitle">
        {t('hotDeals/subTitle', '* Not all deals include extra services')}
      </Paragraph>
      <DealsMobileWrapper isMobile={isMobile}>
        <Deals isMobile={isMobile} data-test-id="hot-deals-list">
          {deals.map((item, index) => (
            <Deal key={item.id} index={index} item={item} />
          ))}
        </Deals>
      </DealsMobileWrapper>
    </HotDealsWrapper>
  );
};

const HotDealsWrapper = styled.div`
  max-width: ${PAGE_WIDTH}px;
  width: 100%;
  margin: 0 auto;
  padding: 0 ${tokens.fdsComponentSpacingLg};
`;

const DealsMobileWrapper = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          overflow-y: auto;
        `
      : ''}
`;

const Deals = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${tokens.fdsComponentSpacingXxl};

  ${({ isMobile }) =>
    isMobile
      ? css`
          width: fit-content;
          flex-wrap: nowrap;
        `
      : css`
          flex-wrap: wrap;
          overflow: hidden;
        `}
`;

const mapStateToProps = (store) => ({
  deals: dealsSelector(store),
  isMobile: isMobileSelector(store),
  isLoggedIn: isLoggedIn(store),
  preferences: getPreferences(store)
});

export default connect(mapStateToProps, {
  getDeals
})(HotDeals);
